<template>
  <div class="home">
    <div id="content" class="snap-content bg-home">
      <div class="container">
        <div class="header-clear mt-15"></div>

        <div class="itemList-header">
          <h1>Solicitud confirmada</h1>
        </div>

        <div class="item-Form">
          <div class="panel-body redireccion-container">
            <div class="logo-container" aria-hidden="true">
              <img :src="gif" alt="" class="logo-animado" />
            </div>

            <h2>¡Todo listo!</h2>

            <p class="mensaje">La solicitud se ha confirmado correctamente.</p>

            <p>
              Serás redirigido automáticamente a la página principal en
              <strong>
                {{ segundosRestantes }}
                {{ segundosRestantes === 1 ? "segundo" : "segundos" }} </strong
              >.
            </p>

            <div
              class="barra-progreso"
              role="progressbar"
              :aria-valuenow="porcentajeRestante"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              <div
                class="barra-progreso-interior"
                :style="{ width: porcentajeRestante + '%' }"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import gif from "@/assets/gif-transparente.gif";

export default {
  name: "Redireccion",

  components: {
    Footer,
  },

  data() {
    return {
      gif,
      duracion: 6,
      segundosRestantes: 6,
      intervalo: null,
    };
  },

  computed: {
    porcentajeRestante() {
      return (this.segundosRestantes / this.duracion) * 100;
    },
  },

  mounted() {
    document.body.classList.remove("bg-login");
    document.body.classList.remove("login-page");

    this.iniciarTemporizador();
  },

  beforeDestroy() {
    this.detenerTemporizador();
  },

  methods: {
    iniciarTemporizador() {
      this.intervalo = window.setInterval(() => {
        this.segundosRestantes -= 1;

        if (this.segundosRestantes <= 0) {
          this.redirigirAHome();
        }
      }, 1000);
    },

    detenerTemporizador() {
      if (this.intervalo !== null) {
        window.clearInterval(this.intervalo);
        this.intervalo = null;
      }
    },

    async redirigirAHome() {
      this.detenerTemporizador();

      await this.$router.replace({
        name: !!!this.$store.state.token ? "Login" : "Home",
      });
    },
  },
};
</script>

<style scoped>
@import "../assets/styles/home.css";

.redireccion-container {
  max-width: 600px;
  margin: 35px auto;
  padding: 45px 30px;
  text-align: center;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
  animation: aparecer 0.5s ease-out;
}

.redireccion-container h2 {
  margin-top: 18px;
  font-size: 28px;
}

.mensaje {
  font-size: 17px;
  margin-bottom: 10px;
}

.logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 180px;
  margin-bottom: 15px;
}

.logo-animado {
  display: block;
  width: min(280px, 80vw);
  height: auto;
  object-fit: contain;
}

.barra-progreso {
  width: 100%;
  height: 10px;
  margin: 25px 0 0;
  overflow: hidden;
  background: #e9ecef;
  border-radius: 10px;
}

.barra-progreso-interior {
  height: 100%;
  background: #e63331;
  border-radius: 10px;
  transition: width 1s linear;
}

@keyframes aparecer {
  from {
    opacity: 0;
    transform: translateY(15px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .redireccion-container {
    animation: none;
  }

  .barra-progreso-interior {
    transition: none;
  }
}
</style>
